import '../../monitoring/filters/grouped_elements/grouped_elements_filter_view.js.coffee'

Namespace 'Customer.Filters'

class Customer.Filters.TagsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView
  template: JST['backbone/templates/customer/filters/tags_filter']
  selectAll: true
  alias: 'Intelligent Tag'
  className: 'tag-filter'

  events: =>
    return _.extend {}, Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView.prototype.events,
      'click .tags-filter-cancel-button': '_closeModal'
      'click .tags-filter-apply-button': '_applyFilter'

  initialize: (@options = {}) ->
    @searchQuery = new Monitoring.Models.SearchQuery(@options.intelligentTags, {})
    @groups_logic = @getGroupsLogic()
    @possible_elements = @initilizeElements()
    @applied_elements = @initilizeElements()

    @tagsByClientCode = _.reduce(@options.tagsByClientCode,
      (memo, obj) -> memo[obj['code']] = obj.description; memo,
      {})
    terms = _.map(_.clone(@options.tagsByClientCode), (obj) -> obj.term = obj.code; obj)
    @terms = _.sortBy(terms, (term) => @getDescription(term).toLowerCase())
    @applyButtonClicked = false

  onEditElements: (event) ->
    @$el.find('#edit_elements_modal').addClass('modal')
    super

  getGroupsLogic: ->
    'first_group_elements':    @searchQuery.get(@withPrefix('primary_tags_logic')),
    'second_group_elements':   @searchQuery.get(@withPrefix('secondary_tags_logic')),
    'excluded_group_elements': @searchQuery.get(@withPrefix('excluded_tags_logic'))

  getGroupsElements: ->
    first_group_elements: @withPrefix('primary_tags')
    second_group_elements: @withPrefix('secondary_tags')
    excluded_group_elements: @withPrefix('excluded_tags')

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.TagsFilterGroupView(@optionsFor(viewId))

  optionsFor: (viewId) =>
    _.extend {}, super(viewId), useKeepconModal: true

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group_elements')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group_elements')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group_elements')

  getValues: ->
    {
      primary_tags: _.pluck(@firstGroupView.appliedElements, 'term'),
      secondary_tags: _.pluck(@secondGroupView.appliedElements, 'term'),
      excluded_tags: _.pluck(@excludedGroupView.appliedElements, 'term'),
      primary_tags_logic: @firstGroupView.logic,
      secondary_tags_logic: @secondGroupView.logic,
      excluded_tags_logic: @excludedGroupView.logic,
    }

  _generateAllElements: (terms)->
    tags = []
    for term, description of @tagsByClientCode
      facet = _.find(terms, (node) -> node.term == term)
      if facet
        count = facet.count
      else
        count = 0
      hidden = Keepcon.hiddenTags[term] == true
      tags.push({ term: term, description: description, count: count , hidden: hidden , custom: false}) unless hidden
    return tags

  getName: ->
    'tags'

  canFilterOnlyPresent: ->
    false

  _applyFilter: ->
    @onApply()
    @applyButtonClicked = true
    @_closeModal()

  _closeModal: ->
    @trigger 'modal:close'

  clearIfCanceled: =>
    @render() unless @applyButtonClicked
    @applyButtonClicked = false

  _noValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.no_tags')

  _allValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.tags.any_tag')
